const EventService = {

  fetchAll() {
    return new Promise((resolve, reject) => {
      axios.get('events')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  fetchOne(eventId) {
    return new Promise((resolve, reject) => {
      axios.get(`events/${eventId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  store(payload) {
    return new Promise((resolve, reject) => {
      axios.post('events', payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  update(eventId, payload) {
    return new Promise((resolve, reject) => {
      axios.patch(`events/${eventId}`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  delete(eventId) {
    return new Promise((resolve, reject) => {
      axios.delete(`events/${eventId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default EventService;
